// @flow
import React, { Component } from 'react';
import {
  Link
} from 'react-router-dom';

type ButtonProps = {
  id: string,
  label: string,
  formButton: boolean,
  urlTo: string,
  onClick: (number: string) => void,
  onMouseEnter: any,
  onMouseLeave: any,
  iconName: string,
  icon: string,
  className?: string,
  isLoading: boolean,
  isDisabled: boolean,
  children: any,
  isComplete?: string,
  filterButton?: boolean,
  selected?: boolean,
  isPrimary: boolean,
  iconSize?: string, // small, x-small, large, x-large
  iconPadding?: boolean,
  iconRight?: boolean,
  style?: {}
}

type State = {
  isHovered: boolean
}

export default class Button extends Component {
  state: State = {
    isHovered: false
  };

  onMouseEnter = () => {
    this.setState({ isHovered: true });
  }

  onMouseLeave = () => {
    this.setState({ isHovered: false });
  }

  getIconColour = (isPrimary) => {
    if ((this.state.isHovered && !this.props.isDisabled) || isPrimary) {
      return 'is-white';
    }
    return 'is-purple';
  }

  props: ButtonProps;

  render() {
    // assumes that, otherwise, the button is-secondary
    let isPrimary = false;
    if (this.props.className && this.props.className.includes('is-primary')) {
      isPrimary = true;
    }

    const icon = (
      <i className={this.props.iconName && `icon
        ${this.props.iconName}
        ${this.getIconColour(isPrimary)}
        ${this.props.iconSize ? this.props.iconSize : 'is-medium'}
        ${this.props.iconPadding ? '' : 'is-tight'}
        ${this.props.iconRight ? 'icon-right' : ''}`}
      />
    );

    const className = `btn
          ${this.props.isLoading ? 'is-loading' : ''}
          ${this.props.isDisabled ? 'is-disabled-opacity' : ''}
          ${this.props.isComplete ? 'is-complete' : ''}
          ${this.props.className}`;

    if (this.props.filterButton) {
      return (
        <button
          style={this.props.selected ? { border: '1px solid transparent', color: '#fff' } : {}}
          className={this.props.className}
          type='submit'
          onMouseEnter={this.props.onMouseEnter}
          onMouseLeave={this.props.onMouseLeave}
          onClick={this.props.onClick}
          id={this.props.id || ''}
        >
          <span>{this.props.label}</span>
          {this.props.selected && <i className='icon is-x-small ic-close' />}
        </button>
      );
    } else if (this.props.formButton) {
      return (
        <button className={className} type='submit' id={this.props.id || ''}>
          {this.props.isLoading ? (
            <i className='spin' style={{ marginRight: 0 }} />
          ) : (
            <React.Fragment>
              <span>{this.props.label}</span>
              {this.props.iconRight && icon}
            </React.Fragment>
          )}
        </button>
      );
    } else if (this.props.urlTo) {
      return (
        <Link
          className={className}
          to={this.props.urlTo}
          id={this.props.id || ''}
          rel='noopener noreferrer'
        >
          {this.props.isLoading ?
            <i className='spin' style={{ marginRight: 0 }} />
            : <span>{this.props.label}</span>
          }
        </Link>
      );
    }
    return (
      <button
        className={className}
        onClick={this.props.onClick}
        id={this.props.id || ''}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        disabled={this.props.isDisabled}
      >
        {this.props.isLoading && <i className='spin' />}
        {!this.props.isLoading && !this.props.iconRight && icon}
        {this.props.children}
        <span>{this.props.label}</span>
        {this.props.iconRight && icon}
      </button>
    );
  }
}

Button.defaultProps = {
  isComplete: false,
  className: 'is-primary',
  isDisabled: false
};



// WEBPACK FOOTER //
// ./src/components/shared/Button.js